var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccountantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1441 1.928C12.1441 0.864 13.0081 0 14.0721 0C15.1361 0 16.0001 0.864 16.0001 1.928C16.0001 2.992 15.1361 3.856 14.0721 3.856C13.0081 3.856 12.1441 2.992 12.1441 1.928ZM9.064 10.2074L11.376 7.22424L11.344 7.24024C11.472 7.06424 11.496 6.84024 11.408 6.64024C11.3208 6.44024 11.128 6.30424 10.9208 6.28824C10.704 6.26424 10.4888 6.36024 10.36 6.53624L8.4248 9.04024L6.208 7.29624C6.072 7.19224 5.912 7.15144 5.752 7.16824C5.5928 7.19224 5.4488 7.27944 5.352 7.40744L2.9848 10.4882L2.936 10.5602C2.8 10.8154 2.864 11.1434 3.104 11.3202C3.216 11.3922 3.336 11.4402 3.472 11.4402C3.6568 11.4482 3.832 11.3514 3.944 11.2002L5.952 8.61544L8.232 10.3282L8.304 10.3754C8.56 10.5114 8.88 10.4482 9.064 10.2074ZM10.76 1.42424C10.728 1.62424 10.712 1.82424 10.712 2.02424C10.712 3.82424 12.168 5.27944 13.96 5.27944C14.16 5.27944 14.352 5.25624 14.552 5.22424V11.6794C14.552 14.3922 12.952 16.0002 10.232 16.0002H4.3208C1.6 16.0002 0 14.3922 0 11.6794V5.76024C0 3.04024 1.6 1.42424 4.3208 1.42424H10.76Z",
    fill: "#2246DC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountantIcon);
export default __webpack_public_path__ + "static/media/accountant-icon.4d9f619f864091172f96c425d6a7cb17.svg";
export { ForwardRef as ReactComponent };